import { defineTable } from "convex/server";
import { v } from "convex/values";
import { notificationSettingsValidator } from "../system/notifications/preferences";

// Nuevos tipos para multi-empresa
export const companyStatus = v.union(
  v.literal("active"),
  v.literal("inactive"),
  v.literal("suspended"),
);

export const validatorCompany = v.object({
  // new fields (didn't exist in old version)
  name: v.string(), // Nombre de la empresa
  description: v.optional(v.string()), // Descripción de la empresa
  legalName: v.optional(v.string()), // Razón social completa
  taxId: v.optional(v.string()), // RTN o identificación fiscal
  email: v.optional(v.string()), // Email principal de la empresa
  phone: v.optional(v.string()), // Teléfono principal
  address: v.optional(v.string()), // Dirección física
  city: v.optional(v.string()), // Ciudad
  state: v.optional(v.string()), // Estado/Departamento
  country: v.optional(v.string()), // País
  website: v.optional(v.string()), // Sitio web
  logoId: v.optional(v.id("_storage")), // Logo de la empresa
  status: v.optional(companyStatus), // active/inactive/suspended
  // Configuración empresarial
  defaultCurrency: v.optional(v.string()), // Moneda por defecto (HNL, USD, etc.)
  defaultTaxRate: v.optional(v.number()), // Tasa de impuesto por defecto
  paymentTerms: v.optional(v.string()), // Términos de pago por defecto
  defaultProfitMargin: v.optional(v.number()), // Margen de ganancia por defecto
  // Configuración de ubicación - Filtrado de países y estados
  allowedCountries: v.optional(v.array(v.string())), // Array de códigos de país habilitados (ej: ["HN", "US"])
  allowedStatesByCountry: v.optional(v.record(v.string(), v.array(v.string()))), // Estados por país (ej: {US: ["CA", "TX"]})
  hideZipCode: v.optional(v.boolean()), // Ocultar input de código postal en LocationField
  // Notificaciones
  notificationSettings: v.optional(notificationSettingsValidator),
  // Timestamps
  createdAt: v.optional(v.number()),
  updatedAt: v.optional(v.number()),
});

export const companies = defineTable(validatorCompany)
  .index("by_status", ["status"])
  .index("by_tax_id", ["taxId"])
  .index("by_name", ["name"])
  .searchIndex("search_companies", {
    searchField: "name",
    filterFields: ["status"],
  });
